import { v4 } from 'uuid';

import networkActions from '../../../../actions/network';
import { CustomRouterHistory } from '../../../../createHistory';
import { getLang } from '../../../../i18n/l10n';
import { EntitiesMissions } from '../../../../states/entities/missions';
import { HandlerProps } from '../../../../store/synchronousMiddleware';
import { RouterActionTypes } from '../../../../types/actions/router';
import RoutesRedirectionFactory from '../../../../utils/routes/RoutesRedirectionFactory';
import { refreshUserMissionsState } from '../../actions/userMissions';
import { LocalStorageMissionsKeys } from '../../constants/storage';
import { MISSIONS_STATE_TRANSITION_DELAY, MISSIONS_STATE_TRANSITION_DURATION } from '../../constants/transitions';
import { MissionsStateActionTypes } from '../../types/actions/missions';
import { UserMissionsStateActionTypes } from '../../types/actions/userMissions';

type AvoidUnknownMissionPropsType = {
  history: CustomRouterHistory;
  currMissions: EntitiesMissions;
};

const avoidUnknownMission = ({ history, currMissions }: AvoidUnknownMissionPropsType) => {
  const { location } = history;

  const missionDetailsMatch = location?.hash?.match(/^#mission-details-(\d+)$/);
  const missionId = missionDetailsMatch?.[1] ? parseInt(missionDetailsMatch?.[1], 10) : undefined;

  if (missionId) {
    const hasData = currMissions[missionId];

    if (!hasData && location?.pathname) {
      history.goBackOrReplace(location.pathname);
    }
  }
};

export const handledActionTypes: Array<string> = [
  MissionsStateActionTypes.OPT_IN_REQUEST,
  RouterActionTypes.ROUTE_HAS_CHANGED,
  UserMissionsStateActionTypes.REQUEST_REFRESH_USER_MISSIONS_STATE,
];

const missionsMiddlewareHandler = ({ store: { dispatch, getState }, action, params: { history } }: HandlerProps) => {
  const { payload = {}, hooks } = action;
  const state = getState();
  const { entities } = state;
  const { missions: currMissions } = entities ?? {};

  if (handledActionTypes.indexOf(action.type) !== -1) {
    if (action.type === MissionsStateActionTypes.OPT_IN_REQUEST) {
      const { missionId } = payload;

      if (typeof missionId === 'number') {
        const queryId = v4();

        dispatch(
          networkActions.send(
            {
              missions: {
                id: queryId,
                method: 'registerUser',
                params: {
                  missionId,
                },
              },
            },
            { queryId, hooks },
          ),
        );
      }
    }

    if (action.type === RouterActionTypes.ROUTE_HAS_CHANGED) {
      const { payload } = action;

      const { pathname, hash } = payload;

      if (
        (pathname && pathname.indexOf(RoutesRedirectionFactory.getExtrasRoutePathname()) !== -1) ||
        (hash && hash.indexOf('mission') !== -1)
      ) {
        avoidUnknownMission({ history, currMissions });

        /* on setItem chaque entity dans le localstorage */

        setTimeout(() => {
          const realTimeState = getState();
          const { missions: RTCurrMissions, achievements: RTCurrAchievements } = realTimeState.entities;
          const { userMissions: RTCurrUserMissions, user: RTCurrUser } = realTimeState;

          const subRTCurrentUser = {
            connected: RTCurrUser.connected,
            nicknameJustChanged: RTCurrUser.nicknameJustChanged,
            promotionStatus: RTCurrUser.promotionStatus,
            missionsModerator: RTCurrUser.missionsModerator,
            lang: getLang(),
          };

          localStorage.setItem(LocalStorageMissionsKeys.MISSIONS, JSON.stringify(RTCurrMissions));
          localStorage.setItem(LocalStorageMissionsKeys.ACHIEVEMENTS, JSON.stringify(RTCurrAchievements));
          localStorage.setItem(LocalStorageMissionsKeys.USER_MISSIONS, JSON.stringify(RTCurrUserMissions));
          localStorage.setItem(LocalStorageMissionsKeys.USER, JSON.stringify(subRTCurrentUser));
        }, MISSIONS_STATE_TRANSITION_DURATION + MISSIONS_STATE_TRANSITION_DELAY);
      }
    }

    if (action.type === UserMissionsStateActionTypes.REQUEST_REFRESH_USER_MISSIONS_STATE) {
      setTimeout(() => {
        dispatch(refreshUserMissionsState());
      }, 1000);
    }
  }
};

export default missionsMiddlewareHandler;
